import { useStore } from 'effector-react'
import { Form } from '~/entities/common/Taxipark/Employee'
import { formSubmitted, createFx } from './model'

export function AddEmployee() {
  const isCreating = useStore(createFx.pending)

  return <Form isSubmitting={isCreating} isCreating onSuccess={formSubmitted} />
}
